import React from 'react';

import { ILinkFields } from '../../../../../types/contentful';

import { FooterLink, FooterNavItem } from './styles';

export function Link({
  title,
  url,
  openInNewTab,
  hasAffiliateLink
}: ILinkFields) {
  const path = url ?? '';
  return (
    <FooterNavItem>
      <FooterLink
        href={hasAffiliateLink ? `/affiliates${path}` : path}
        target={openInNewTab ? '_blank' : ''}
        rel="noopener noreferrer"
      >
        {title}
      </FooterLink>
    </FooterNavItem>
  );
}
